import bookingRoutes from "@booking/app/booking/routes";
import { BOOKING } from "@booking/paths";
import { createMemoryRouter, Navigate } from "react-router-dom";

export const routes = [
  { path: "/healthz" },
  {
    path: "/:venues",
    element: <Navigate to={BOOKING.ROOT} />,
  },
  bookingRoutes,
];

const router = createMemoryRouter(routes);

export { router as default };
